import { FC } from "react";
import { useLocation } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { useAppStore } from "@/store";
import { toastModule } from "@/modules/toast";
import { localStorageModule } from "@/modules/local-storage";
import { logger } from "@/modules/logger";
import { useEffectOnMount } from "@/domains/react/useEffectOnMount";
import { appRoutes } from "@/app/router/appRoutes";
import { SettingsTabId } from "@/store/pages/SettingsPageStore/types";
import { TabOpeningStrategy } from "@/store/navigation/NavigationTabManager";

export const IntegrationsSlackCallbackPage: FC = observer(() => {
  const { store } = useAppStore();
  const location = useLocation();

  useEffectOnMount(() => {
    const params = new URLSearchParams(location.search);
    const success = params.get("success");
    const error = params.get("error");

    const storedState = localStorageModule.readSlackOAuthState();
    localStorageModule.clearSlackOAuthState();

    const goToMemAgentSettings = () => {
      if (!(store.spaceAccountFeatureFlags.getFlagStatus("mem-agent") ?? false)) {
        store.navigation.tabs.openTab({
          path: appRoutes.notesList({}).path,
          strategy: TabOpeningStrategy.SAME_TAB,
          config: {
            routerOptions: {
              replace: true,
            },
          },
        });
        return;
      }

      store.navigation.tabs.openTab({
        path: `${appRoutes.notesList({}).path}?settings=${SettingsTabId.MemAgentPage}`,
        strategy: TabOpeningStrategy.SAME_TAB,
        config: {
          routerOptions: {
            replace: true,
          },
        },
      });
    };

    if (error || success === "false") {
      logger.error({
        message: "[IntegrationsSlackCallbackPage] Slack OAuth failed",
        info: { error: error ?? "unknown_error" },
      });

      toastModule.triggerToast({
        content: "Failed to connect Slack. Please try again.",
      });

      goToMemAgentSettings();
      return;
    }

    if (!storedState) {
      logger.warn({
        message: "[IntegrationsSlackCallbackPage] Missing OAuth state in localStorage",
      });
    }

    if (success === "true") {
      toastModule.triggerToast({
        content: "Slack connected!",
      });

      void store.memAgent.reload();
      goToMemAgentSettings();
      return;
    }

    toastModule.triggerToast({
      content: "Slack connection failed. Please try again.",
    });

    goToMemAgentSettings();
  });

  return null;
});
